import { Link } from "react-router-dom"
import { ChevronRight, Home } from "lucide-react"

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav className="flex items-center text-sm text-gray-500 mb-4">
      <Link to="/goods" className="flex items-center hover:text-[#ff9906]">
        <Home size={16} className="mr-1" />
        Home
      </Link>

      {items.map((item, index) => (
        <div key={index} className="flex items-center">
          <ChevronRight size={14} className="mx-2" />
          {index === items.length - 1 ? (
            <span className="text-gray-800 font-medium">{item.label}</span>
          ) : (
            <Link to={item.href} className="hover:text-[#ff9906]">
              {item.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  )
}
